import { render, staticRenderFns } from "./m-block-activate-premium.vue?vue&type=template&id=74c9cbad&scoped=true&lang=pug"
import script from "./m-block-activate-premium.vue?vue&type=script&lang=js"
export * from "./m-block-activate-premium.vue?vue&type=script&lang=js"
import style0 from "./m-block-activate-premium.vue?vue&type=style&index=0&id=74c9cbad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c9cbad",
  null
  
)

export default component.exports